.peachyLogo_PeachyLogo_76fec6e{width:8.8em;height:auto}